import w600 from "./w600"
import w1080 from "./w1080"
import w360 from "./w360"
import w280 from "./w280"
import w1250 from "./w1250"
import w800 from "./w800"

export default {
  w1080,
  w600,
  w360,
  w280,
  w1250,
  w800
}